<template lang="pug">
  .page-asset-management
    .component-backoffice-category-list.row.column
      .row
        .column.small-12.large-4.category(v-for="(parkingGroup, index) in parkingGroups", :class="{ active: activeIndex === index}")
          .inner-content.card
            .row
              .column(style="text-align:left") PG{{parkingGroup.id}} {{ parkingGroup.name }} &nbsp;
              .column.shrink
                dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'", v-if="activeIndex === index")
                  ParkingGroupButtons(:item="parkingGroup")
            .row
              .column(@click="setSearch(index,parkingGroup)")
                h3
                  small PG{{parkingGroup.id}}&nbsp;
                  span {{ parkingGroup.name }}
                template(v-if="parkingGroup.city")

                  h3
                    small C{{parkingGroup.id}}&nbsp;
                    span {{parkingGroup.city.name}}
                small BM: {{parkingGroup.reservation_type}}

      .row(v-for="(parkingGroup, index) in parkingGroups", v-if="activeIndex === index")
        .column.text.left
          router-link(:to="{name:'add-parking-lot', params:{id:parkingGroup.id}}")
            button.button.small Add new Parking Lot
      .row.column
        base-list(v-if="parking_group !== null" :component="component", :dataLoader="dataLoader", :search="search")
</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import Accordion from 'components/structure/foundation/Accordion/Accordion'
import AccordionItem from 'components/structure/foundation/Accordion/AccordionItem'
import BaseList from './BaseList'
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import CreateParkingLot from '../../components/structure/ui/actions/CreateParkingLot'
import EditParkingGroup from '../../components/structure/ui/actions/asset-management/EditParkingGroup'
import DeleteParkingGroup from '../../components/structure/ui/actions/asset-management/DeleteParkingGroup'
import Dropdown from "../../components/structure/foundation/Dropdown.vue";
import ParkingGroupButtons from "../../components/structure/ui/actions/ParkingGroupButtons.vue";
import {EventBus} from "../../eventBus";

export default {
  name: 'AssetManagement',
  components: {
    ParkingGroupButtons,
    Dropdown,
    DeleteParkingGroup,
    EditParkingGroup,
    CreateParkingLot,
    ModalReveal,
    BaseList,
    Accordion,
    AccordionItem,
  },
  data() {
    return {
      parkingGroups: null,
      parking_group: null,
      parkingLots: {},
      component: require('src/components/backoffice/ParkingLot.vue'),
      search: {},
      activeIndex: 0
    }
  },
  destroyed() {
    EventBus.$on('reload-list')
  },
  created() {
    this.loadParkingGroups()
    EventBus.$on('reload-list', () => {
      this.loadParkingGroups()
    })
  },
  methods: {
    loadParkingGroups(activeIndex = 0) {
      KeplerBackofficeSdk.parkingGroups.list.allv3((data) => {
        this.parkingGroups = data.items
        this.setSearch(activeIndex, this.parkingGroups[0])
      })
    },
    setSearch(index, parkingGroup) {
      this.parking_group = parkingGroup
      this.activeIndex = index
      this.search = {
        parking_group_id: parkingGroup.id
      }
    },
    dataLoader(callback, page, resultsPerPage) {
      return KeplerBackofficeSdk.parkingGroups.select(this.parking_group).parkingLots({
        per_page: resultsPerPage,
        page_number: page
      }, (data) => {
        callback(data)
      })
    }
  }
}
</script>
<style lang="sass" rel="stylesheet/sass">
.page-asset-management
  margin: 0
</style>



// WEBPACK FOOTER //
// AssetManagement.vue?3519cba8